module.exports = __webpack_public_path__ + "static/media/locked-yellow.2fbd896e.svg";